import moment from 'moment';
const filters = {
  filters: {
    formatDate: function(value) {
      return value ? moment(value).format('DD.MM.YYYY à HH:mm') : '';
    },
    formatDateForMail: function(value) {
      const today = moment();
      const yesterday = moment().subtract(1, 'day');
      if (moment(value).isSame(today, 'day')) {
        return moment(value).format('HH:mm');
      }
      if (moment(value).isSame(yesterday, 'day')) {
        return 'hier';
      }
      return moment(value).format('DD.MM.YY');
    },
    formatDateForMailHeader: function(value) {
      return moment(value).locale('fr').format('D MMMM YYYY à HH:mm');
    },
    formatMode: function(value) {
      return value
        .split(' ')
        .map(v => v.substr(0, 1).toUpperCase())
        .join('');
    }
  }
};

export { filters };
